module.exports = __webpack_public_path__ + "static/media/RickCEO.620cd434.jpg";